//Custo css import
import './style.css'
import Table from '../../molecules/tablas/view'
import TabSwitcher from '../../molecules/TabSwitcher/view'
import { useContext, useEffect, useState, useCallback } from 'react'
import { enviarMensaje, createPdfBlob, createPdfUrl, getConflictedSalesList, handleResolveConflict } from './controller'
import { useNavigationIntent } from '../../../hooks/useNavigationIntent'

import ButtonAction from '../../atoms/buttonAction/view'

import { dispatchCustomEvent, listener } from '../../../utils/dispatch'
import ButtonGroup from '../../molecules/buttonGroup/view'

import ElectronicDocsSettings from '../../organisms/invoiceDataForm/view'
import InvoicingAuditModal from '../../organisms/InvoicingAuditModal/view'

import ButtonBasic from '../../atoms/buttonBasic/view'

import { getInvoices, getCreditNotes, createCreditNote } from '../../../usecases/documents-usecase'
import { getThirdById, getThirdByIdentification, editThird } from '../../../usecases/thirds-usecase'
import { BsEye, BsArrowRepeat } from 'react-icons/bs'
import { BiErrorCircle } from 'react-icons/bi'
import { roleContext } from '../../../context/role/context'
import { EmptyArray } from '../../../app/domain/models/empty/empty'
import ReceiptTable from '../../organisms/ReceiptTable/view'
import CustomBox from '../../atoms/container/container'
import LoadingView from '../../pages/loading/loading-view'
import InvoicesTable from '../../organisms/InvoicesTable/view'
import RadianEventsTable from '../../organisms/RadianEventsTable/view'
import ThirdForm from '../../organisms/thirdForm/view'
import TooltipC from '../../atoms/tooltip/view'

import ConfirmPopUp from '../../atoms/confirmPopUp/view'
import FacetedFilter from '../../molecules/FacetedFilter/view'
import Chip from '../../atoms/chip/container'
import Modal from '../../atoms/modal/view'
import { showInvoicePDF } from '../../../usecases/payments-usecase'
import { Calendar, Tag } from 'lucide-react'
import { lang } from '../../../utils/langs'

function Invoice() {

    const { profile, isElectronicInvoiceEnable, suscripcion } = useContext(roleContext)

    const [invoices, setInvoices] = useState({
        data: [],
        page: 1,
        page_size: 50,
        total: 0,
    })

    const [notasCredito, setCreditNotes] = useState({
        data: [],
        page: 1,
        page_size: 50,
        total: 0,
    })

    const [conflicts, setConflicts] = useState({
        data: [],
        page: 1,
        page_size: 50,
        total: 0,
    })

    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const intent = useNavigationIntent();

    useEffect(() => {
        if (intent && intent.tabIndex !== undefined) {
            setActiveTabIndex(intent.tabIndex);
        }
    }, [intent]);

    const [forceReceips, setForceReceips] = useState(0)
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingCreditNotes, setIsLoadingCreditNotes] = useState(false);
    const [isLoadingConflicts, setIsLoadingConflicts] = useState(false);
    const [selectedThirdForConflict, setSelectedThirdForConflict] = useState(null);
    const [conflictBillId, setConflictBillId] = useState(null);
    const [creditNotePdfUrl, setCreditNotePdfUrl] = useState(null);

    const handleCloseCreditNotePdf = () => {
        if (creditNotePdfUrl) {
            URL.revokeObjectURL(creditNotePdfUrl);
            setCreditNotePdfUrl(null);
        }
    };

    const [activeFilters, setActiveFilters] = useState([]);

    const filtersConfig = [
        {
            key: 'status',
            label: 'Estado',
            icon: <Tag size={14} />,
            options: [
                { value: 'success', label: 'Emitidas (Vigentes)' },
                { value: 'cancelled_nc', label: 'Anuladas con Nota Crédito' },
                { value: 'pending', label: lang('es', 'pending') },
                { value: 'error', label: lang('es', 'error') }
            ]
        },
        { key: 'date_from', label: 'Fecha Desde', icon: <Calendar size={14} />, type: 'date' },
        { key: 'date_to', label: 'Fecha Hasta', icon: <Calendar size={14} />, type: 'date' }
    ];

    // Convert activeFilters from FacetedFilter to backend parameters
    const getFilterParams = (filtersList) => {
        let status = undefined;
        let date_from = undefined;
        let date_to = undefined;

        filtersList.forEach(item => {
            if (item.key === 'status') status = item.value;
            if (item.key === 'date_from') date_from = item.value;
            if (item.key === 'date_to') date_to = item.value;
        });

        return { status, date_from, date_to };
    };

    const handleFilterChange = (newFilters) => {
        setActiveFilters(newFilters);
        const { status, date_from, date_to } = getFilterParams(newFilters);
        handleInvoices(1, invoices.page_size, status, date_from, date_to);
    };

    const handleFetchConflicts = useCallback(
        async (page = conflicts.page, limit = conflicts.page_size) => {
            setConflicts((prev) => ({ ...prev, data: [] }));
            setIsLoadingConflicts(true);
            try {
                const result = await getConflictedSalesList(page, limit);
                setConflicts(result);
            } catch (error) {
                console.error('Error fetching conflicts:', error);
            } finally {
                setIsLoadingConflicts(false);
            }
        },
        [conflicts.page, conflicts.page_size]
    );

    const onResolveClick = async (row, force = false) => {
        const item = row._original || row;
        const conflictType = item.conflict_type;

        // Si es conflicto por datos de cliente y no se está forzando re-emisión
        if (conflictType === 'CLIENT_DATA' && !force && (item.thirds_id || item.customer_id)) {
            setIsLoading(true);
            try {
                let thirdData = null;
                if (item.thirds_id) {
                    thirdData = await getThirdById(item.thirds_id);
                } else if (item.customer_id) {
                    thirdData = await getThirdByIdentification(item.customer_id);
                }

                if (thirdData) {
                    setSelectedThirdForConflict(thirdData);
                    setConflictBillId(item.bill_id);
                    dispatchCustomEvent('modalconflict-edit-third');
                    return;
                }
            } catch (err) {
                console.warn('No se pudo cargar tercero completo, usando datos básicos:', err);
                setSelectedThirdForConflict({
                    id: item.thirds_id,
                    identification: item.customer_id,
                    name: item.customer,
                });
                setConflictBillId(item.bill_id);
                dispatchCustomEvent('modalconflict-edit-third');
                return;
            } finally {
                setIsLoading(false);
            }
        }

        // Para Timeouts / Pending / Excepciones o re-emisión forzada
        setIsLoading(true);
        try {
            const result = await handleResolveConflict(item.bill_id, force);
            if (result?.requires_confirmation) {
                dispatchCustomEvent(
                    'notification-confirm-invoice-resolve-conflict',
                    result.requires_confirmation ? item : {}
                );
            } else if (result?.success) {
                handleFetchConflicts();
                const { status, date_from, date_to } = getFilterParams(activeFilters);
                handleInvoices(1, invoices.page_size, status, date_from, date_to);
            }
        } catch (error) {
            console.error('Error resolving conflict:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleConflictThirdSubmit = async (formData) => {
        setIsLoading(true);
        try {
            const thirdId = formData.id || selectedThirdForConflict?.id;
            if (thirdId) {
                await editThird(thirdId, formData);
            }
            dispatchCustomEvent('modal-close-conflict-edit-third');
            dispatchCustomEvent('popup', {
                message: 'Cliente actualizado. Re-transmitiendo factura...',
                type: 'success',
            });

            if (conflictBillId) {
                const result = await handleResolveConflict(conflictBillId, true);
                if (result?.success) {
                    handleFetchConflicts();
                    const { status, date_from, date_to } = getFilterParams(activeFilters);
                    handleInvoices(1, invoices.page_size, status, date_from, date_to);
                }
            }
        } catch (err) {
            console.error('Error al actualizar tercero:', err);
            const msg = err.response?.data?.message || 'Error al actualizar datos del cliente';
            dispatchCustomEvent('popup', { message: msg, type: 'error' });
        } finally {
            setIsLoading(false);
            setSelectedThirdForConflict(null);
            setConflictBillId(null);
        }
    };

    const tabs = [
        {
            name: "Facturas",
            component: () => (
                <CustomBox style={{ maxHeight: '90%' }}>
                    <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'flex-end' }}>
                        <FacetedFilter
                            filters={filtersConfig}
                            activeFilters={activeFilters}
                            onChange={handleFilterChange}
                            onClear={() => handleFilterChange([])}
                        />
                    </div>
                    <InvoicesTable 
                        id="invoice-table"
                        invoices={invoices}
                        onReload={(page, limit) => {
                            const { status, date_from, date_to } = getFilterParams(activeFilters);
                            handleInvoices(page, limit, status, date_from, date_to);
                        }}
                    />
                </CustomBox>
            )
        },
        {
            name: "Conflictos",
            badge: conflicts?.total || 0,
            component: () => (
                <CustomBox style={{ maxHeight: '90%' }}>
                    <Table
                        id="conflicts-table-invoice"
                        onReload={() => handleFetchConflicts()}
                        headersList={['Fecha', 'Cliente', 'Documento', 'Total', 'Motivo / Error']}
                        paginatedData={conflicts}
                        getFunction={handleFetchConflicts}
                        excludeList={['bill_id', 'conflict_type', 'thirds_id', 'customer_id', '_original']}
                        isLoading={isLoadingConflicts}
                        allowPageSizeControl={true}
                        formats={{
                            total: { type: 'money' },
                            date: { type: 'timestamp' },
                            error_message: {
                                type: 'custom',
                                children: (item) => {
                                    const msg = item.error_message || 'Sin detalle de error';
                                    return (
                                        <TooltipC text={msg}>
                                            <div className="conflict-error-pill">
                                                <BiErrorCircle size={15} className="conflict-error-icon" />
                                                <span className="conflict-error-text">{msg}</span>
                                            </div>
                                        </TooltipC>
                                    );
                                },
                            },
                        }}
                    >
                        <ButtonAction
                            title={<BsArrowRepeat />}
                            onClick={(data) => onResolveClick(data)}
                        />
                    </Table>
                </CustomBox>
            )
        },
        {
            name: "Eventos RADIAN",
            component: () => (
                <CustomBox style={{ maxHeight: '90%' }}>
                    <RadianEventsTable />
                </CustomBox>
            )
        },
        {
            name: "Recibos de caja",
            component: () => (
                <CustomBox style={{ maxHeight: '90%' }}>
                    <ReceiptTable forceload={forceReceips}></ReceiptTable>
                </CustomBox>
            )
        },
        {
            name: "Notas Credito",
            component: () => (
                <CustomBox style={{ maxHeight: '90%' }}>
                    <Table
                        id='invoice-credit-notes-table'
                        onReload={handleCreditNotes}
                        headersList={[
                            "Fecha",
                            "Estado",
                            "Cliente",
                            "Consecutivo",
                            "Valor"
                        ]}
                        getFunction={handleCreditNotes}
                        paginatedData={notasCredito}
                        excludeList={["uuid", "cude", "sendmail", "emailDeliveryStatus", "preview", "preview_url", "QRStr", "state", "number", "prefix", "customer_id", "time", "id", "created_at", "updated_at"]}
                        isLoading={isLoadingCreditNotes}
                        allowPageSizeControl={true}
                        formats={{
                            value: { type: 'money' },
                            date: { type: 'timestamp' }
                        }}
                    >
                        <ButtonAction
                            enableLoadingAnimation={true}
                            btnKey="credit-note-show-pdf"
                            title={<BsEye></BsEye>}
                            onClick={showCreditNotePDF}
                        />
                    </Table>
                </CustomBox>
            )
        },
        {
            name: "Resoluciones",
            component: () => (
                isElectronicInvoiceEnable ? (
                    <ElectronicDocsSettings profile={profile}></ElectronicDocsSettings>
                ) : (
                    <div class="invoice-settings-container">
                        <p>Para activar esta funcionalidad, por favor contacte con un asesor y solicite la activacion.</p>
                        <div>
                            <ButtonBasic
                                title="Activar"
                                id="btn-activate-invoice"
                                onClick={() => {
                                    enviarMensaje()
                                }}
                            />
                        </div>
                    </div>
                )
            )
        }
    ];

    useEffect(() => {
        if (suscripcion != undefined && !isElectronicInvoiceEnable) {
            dispatchCustomEvent('popup', { message: "Su suscripción no tiene habilitada la funcionalidad de facturación", type: "warning" })
            setTimeout(() => {
                window.location.href = '/hub'
            }, 3000);
        }
    }, [suscripcion, isElectronicInvoiceEnable]);

    useEffect(() => {
        if (activeTabIndex === 4) { // Notas Credito tab
            setCreditNotes(prev => ({ ...prev, data: undefined }))
            handleCreditNotes()
        }
        if (activeTabIndex === 3) { // Recibos de caja
            setForceReceips(prev => prev + 1)
        }
        if (activeTabIndex === 1) { // Conflictos tab
            handleFetchConflicts()
        }
        if (activeTabIndex === 0) { // Facturas tab
            const { status, date_from, date_to } = getFilterParams(activeFilters);
            handleInvoices(1, invoices.page_size, status, date_from, date_to)
        }
    }, [activeTabIndex, handleFetchConflicts])

    useEffect(() => {
        const l1 = listener('reload-invoices', () => {
            const { status, date_from, date_to } = getFilterParams(activeFilters);
            handleInvoices(1, invoices.page_size, status, date_from, date_to);
        });
        const l2 = listener('reload-conflicts', () => handleFetchConflicts());

        return () => {
            l1();
            l2();
        };
    }, [activeFilters, invoices.page_size, handleFetchConflicts]);


    const getChipType = (state) => {
        const types = {
            Emitted: 'success',
            success: 'success',
            pending: 'warning',
            Error: 'error',
            error: 'error',
            Deleted: 'disable',
        };
        return types[state] || 'disable';
    };

    const invoiceMapper = (data) => {
        return data.map((item) => {
            return {
                ...item,
                status: <Chip type={getChipType(item.state)}>{item.state}</Chip>
            }
        })
    }

    const creditNoteMapper = (data) => {
        return data.map((item) => {
            return {
                date: item.date,
                status: <Chip type={getChipType(item.state)}>{lang('es', item.state)}</Chip>,
                customer: item.customer || 'N/A',
                consecutive: item.consecutive || (item.prefix ? `${item.prefix}-${item.number}` : item.number),
                value: item.value || 0,
                _original: item
            }
        })
    }

    async function handleInvoices(
        page = invoices.page, 
        limit = invoices.page_size, 
        status = undefined, 
        dFrom = undefined, 
        dTo = undefined
    ) {
        setInvoices(prev => ({
            ...prev,
            data: []
        }))
        try {
            const data = await getInvoices('', '', page, limit, true, status || undefined, dFrom || undefined, dTo || undefined);
            if (!data?.data || data.data.length === 0) {
                setInvoices(prev => ({ ...prev, data: EmptyArray }));
                return;
            }
            setInvoices(data);
        } catch (error) {
            console.error('Error fetching invoices:', error);
        }

    }



    function handleCreditNotes(page = notasCredito.page, limit = notasCredito.page_size) {
        setIsLoadingCreditNotes(true);
        setCreditNotes(prev => ({
            ...prev,
            data: undefined
        }))
        getCreditNotes('', '', page, limit).then((data) => {
            if (!data?.data || data.data.length == 0) {
                setCreditNotes(prev => ({ ...prev, data: EmptyArray }));
            } else {
                setCreditNotes({ ...data, data: creditNoteMapper(data.data) })
            }
        }
        ).catch((error) => {
            console.error('Error fetching invoices:', error);
            setCreditNotes(prev => ({ ...prev, data: EmptyArray }));
        }).finally(() => {
            setIsLoadingCreditNotes(false);
        });
    }

    async function showCreditNotePDF(row) {
        const data = row._original || row;
        const cude = data.cude;
        const previewUrl = data.preview_url || data.preview;

        if (cude) {
            setIsLoading(true);
            try {
                const response = await showInvoicePDF(cude);
                const pdfData = response?.data || response;
                if (!pdfData) throw new Error("No PDF data");

                const blob = createPdfBlob(pdfData);
                const url = createPdfUrl(blob);
                setCreditNotePdfUrl(url);
                dispatchCustomEvent('modalcredit-note-pdf-preview');
            } catch (error) {
                console.error("Error showing credit note PDF:", error);
                if (previewUrl) {
                    window.open(previewUrl, '_blank');
                } else if (data.QRStr) {
                    const qrArray = data.QRStr.split('\n');
                    window.open(qrArray[qrArray.length - 1], '_blank');
                } else {
                    dispatchCustomEvent('popup', { message: "No se pudo cargar la vista previa de la Nota Crédito", type: "warning" });
                }
            } finally {
                setIsLoading(false);
            }
        } else if (previewUrl) {
            window.open(previewUrl, '_blank');
        } else if (data.QRStr) {
            const qrArray = data.QRStr.split('\n');
            window.open(qrArray[qrArray.length - 1], '_blank');
        } else {
            dispatchCustomEvent('popup', { message: "No hay vista previa disponible para esta Nota Crédito", type: "warning" });
        }
    }


    async function submitCreditNote(data) {
        setIsLoading(true);
        try {
            await createCreditNote(data.prefix, data.number);
            dispatchCustomEvent('loading-btn');
            dispatchCustomEvent('popup', { message: "Nota de credito creada", type: "success" });
            await handleInvoices();
        } catch (error) {
            dispatchCustomEvent('loading-btn');
            const msg = error.response?.data?.message || "Error al procesar la solicitud";
            dispatchCustomEvent('popup', { message: msg, type: "error" });
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            {isLoading && <LoadingView />}
            <ConfirmPopUp
                eventKey="create-nota-credito"
                msg={"Quieres anular la factura creando una nota credito?"}
                onAcept={submitCreditNote}
            />
            <ConfirmPopUp
                eventKey="invoice-resolve-conflict"
                msg={"¿Deseas intentar generar una nueva factura para esta venta?"}
                onAcept={(data) => onResolveClick(data, true)}
            />
            <Modal
                id="conflict-edit-third"
                onClose={() => {
                    setSelectedThirdForConflict(null);
                    setConflictBillId(null);
                }}
                style={{ width: '100%', maxWidth: '850px', maxHeight: '90vh' }}
            >
                {selectedThirdForConflict && (
                    <ThirdForm
                        initialData={selectedThirdForConflict}
                        onSubmit={handleConflictThirdSubmit}
                        loadingId="third-conflict-edit"
                        title="Corregir Datos del Cliente para Facturación"
                        submitLabel="Guardar y Re-transmitir Factura"
                    />
                )}
            </Modal>
            <ButtonGroup
                title="Facturación Electrónica"
                description="Gestiona tus facturas, notas crédito y documentos electrónicos."
            >
                <InvoicingAuditModal onUpdate={handleInvoices} />
            </ButtonGroup>
            <TabSwitcher tabs={tabs} activeTabIndex={activeTabIndex} onTabChange={setActiveTabIndex} hashKey="tab" />


            <Modal
                id="credit-note-pdf-preview"
                className="full-viewport-modal"
                onClose={handleCloseCreditNotePdf}
            >
                <div className="pdf-viewer-container">
                    <div className="pdf-viewer-header">
                        <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 700 }}>Vista Previa de Nota Crédito</h3>
                        <div className="pdf-viewer-actions">
                            <button 
                                onClick={() => {
                                    const iframe = document.querySelector('iframe[title="credit-note-pdf-viewer"]');
                                    if (iframe) {
                                        iframe.contentWindow.focus();
                                        iframe.contentWindow.print();
                                    }
                                }}
                                className="pdf-viewer-btn pdf-viewer-btn-secondary"
                            >
                                Imprimir
                            </button>
                            <button 
                                onClick={() => {
                                    if (!creditNotePdfUrl) return;
                                    const link = document.createElement('a');
                                    link.href = creditNotePdfUrl;
                                    link.download = `NotaCredito.pdf`;
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                }}
                                className="pdf-viewer-btn pdf-viewer-btn-secondary"
                            >
                                Descargar
                            </button>
                            <button 
                                onClick={() => {
                                    dispatchCustomEvent('close-modal-credit-note-pdf-preview');
                                    handleCloseCreditNotePdf();
                                }}
                                className="pdf-viewer-btn pdf-viewer-btn-danger"
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                    <div className="pdf-viewer-iframe-wrapper">
                        {creditNotePdfUrl && (
                            <iframe
                                src={creditNotePdfUrl}
                                className="pdf-viewer-iframe"
                                title="credit-note-pdf-viewer"
                            ></iframe>
                        )}
                    </div>
                </div>
            </Modal>
        </>
    )

}

export default Invoice
